import { apiPostAuth, apiPutAuth, apiGetAuth } from '@/utils/api'
import { API_CLAIM, API_EMPLOYEE } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  claim_list: { 
    isLoading: false,
    data: {}
  },
  claim_dashboard_list: {
    isLoading: false,
    data: {}
  },
  employee_program_list: {
    isLoading: false,
    data: false
  },
  detail_claim: {
    isLoading: false,
    data: {}
  },
  claim_history: {
    isLoading: false,
    data: []
  },
  employee_program_balance: {},
  participant_data: {},
  document_support_claim: {},
  claim_mapping: {
    isLoading: false,
    found: false,
    empty_state: false,
    message: '',
    saldo: 0,
    balance_condition: '',
    allowed_disbursements: [],
    remark: '',
    documents: []
  },
  document_files_by_type_id: {},
  optional_document_files: [],
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  modal_info: {},
  detail_modal_preview: {},
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  },
  meta_filter_2: {
    order_by: 'updated_at',
    sort_by: 'desc',
    program_category: 'PPIP',
    status: 'active'
  }
}

const mutations = {
  "SET_CLAIM_LIST": (state, payload) => {
    state.claim_list = payload
  },
  "SET_CLAIM_DASHBOARD_LIST": (state, payload) => {
    state.claim_dashboard_list = payload
  },
  "SET_DETAIL_CLAIM": (state, payload) => {
    state.detail_claim = payload
  },
  "SET_CLAIM_HISTORY": (state, payload) => {
    state.claim_history = payload
  },
  "SET_EMPLOYEE_PROGRAM_BALANCE": (state, payload) => {
    state.employee_program_balance = payload
  },
  "SET_EMPLOYEE_PROGRAM_LIST": (state, payload) => {
    state.employee_program_list = payload
  },
  "SET_PARTICIPANT_DATA": (state, payload) => {
    state.participant_data = payload
  },
  "SET_MODAL_INFO": (state, payload) => {
    state.modal_info = payload
  },
  "SET_DOCUMENT_SUPPORT_CLAIM": (state, payload) => {
    state.document_support_claim = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_DETAIL_MODAL_PREVIEW": (state, payload) => {
    state.detail_modal_preview = payload
  },
  "SET_CLAIM_MAPPING": (state, payload) => {
    state.claim_mapping = payload
  },
  "SET_DOCUMENT_FILES_BY_TYPE_ID": (state, payload) => {
    state.document_files_by_type_id = payload
  },
  "SET_OPTIONAL_DOCUMENT_FILES": (state, payload) => {
    state.optional_document_files = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  },
  "SET_META_FILTER_2": (state, payload) => {
    state.meta_filter_2 = payload
  }
}

const actions = {
  async getClaimList(context, payload) {
    try {
      context.commit('SET_CLAIM_LIST', { isLoading: true })
      const response = await apiGetAuth(API_CLAIM.LIST, payload)
      context.commit('SET_CLAIM_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_CLAIM_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getClaimDashboardList(context, payload) {
    try {
      context.commit('SET_CLAIM_DASHBOARD_LIST', { isLoading: true })
      const response = await apiGetAuth(API_CLAIM.LIST_DASHBOARD, payload)
      context.commit('SET_CLAIM_DASHBOARD_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_CLAIM_DASHBOARD_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getDetailClaim(context, payload) {
    try {
      context.commit('SET_DETAIL_CLAIM', { isLoading: true })
      const response = await apiGetAuth(API_CLAIM.BY_ID(payload))
      context.commit('SET_DETAIL_CLAIM', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_CLAIM', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async getClaimHistory(context, payload) {
    try {
      context.commit('SET_CLAIM_HISTORY', { isLoading: true, data: [] })
      const response = await apiGetAuth(API_CLAIM.HISTORY(payload))
      context.commit('SET_CLAIM_HISTORY', {
        isLoading: false,
        data: response?.data?.data || []
      })
    } catch (error) {
      context.commit('SET_CLAIM_HISTORY', {
        isLoading: false,
        data: []
      })
      notificationDanger(error)
    }
  },
  async getEmployeeProgramBalance(context, payload) {
    try {
      context.commit('SET_EMPLOYEE_PROGRAM_BALANCE', { isLoading: true })
      // payload bisa string id (default, saldo Core) atau { id, source } —
      // source='journal' dipakai bypass klaim DEV (saldo dari journal, non-prod).
      const id = typeof payload === 'object' ? payload?.id : payload
      const source = typeof payload === 'object' ? payload?.source : ''
      const response = await apiGetAuth(API_CLAIM.EMPLOYEE_PROGRAM_BALANCE(id, source))
      context.commit('SET_EMPLOYEE_PROGRAM_BALANCE', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (error) {
      context.commit('SET_EMPLOYEE_PROGRAM_BALANCE', {
        isLoading: false,
        data: {}
      })
      notificationDanger(error)
    }
  },
  async resolveMapping(context, payload) {
    try {
      context.commit('SET_CLAIM_MAPPING', {
        isLoading: true,
        found: false,
        empty_state: false,
        message: '',
        saldo: payload?.saldo || 0,
        balance_condition: '',
        allowed_disbursements: [],
        remark: '',
        documents: []
      })
      const response = await apiPostAuth(API_CLAIM.RESOLVE_MAPPING, payload)
      const data = response?.data?.data || {}
      context.commit('SET_CLAIM_MAPPING', {
        isLoading: false,
        found: data?.found || false,
        empty_state: data?.empty_state || false,
        message: data?.message || '',
        saldo: data?.saldo || 0,
        balance_condition: data?.balance_condition || '',
        allowed_disbursements: data?.allowed_disbursements || [],
        remark: data?.remark || '',
        documents: data?.documents || []
      })
      return data
    } catch (error) {
      context.commit('SET_CLAIM_MAPPING', {
        isLoading: false,
        found: false,
        empty_state: false,
        message: '',
        saldo: payload?.saldo || 0,
        balance_condition: '',
        allowed_disbursements: [],
        remark: '',
        documents: []
      })
      notificationDanger(error)
    }
  },
  async getEmployeeProgramList(context, payload) {
    try {
      context.commit('SET_EMPLOYEE_PROGRAM_LIST', { isLoading: true })
      const response = await apiGetAuth(API_EMPLOYEE.EMPLOYEE_PROGRAM_LIST, payload)
      context.commit('SET_EMPLOYEE_PROGRAM_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_EMPLOYEE_PROGRAM_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async createClaim(context, payload) {
    try {
      const response = await apiPostAuth(API_CLAIM.CREATE_CLAIM, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateClaim(context, payload) {
    try {
      const response = await apiPutAuth(API_CLAIM.BY_ID(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async uploadTaxReportEvidence(context, { id, formData }) {
    const response = await apiPutAuth(API_CLAIM.TAX_REPORT_EVIDENCE(id), formData)
    return response.data
  },
  async uploadSupportingDocument(context, { id, formData }) {
    const response = await apiPutAuth(API_CLAIM.SUPPORTING_DOCUMENT(id), formData)
    return response.data
  },
  async scanDocumentStructure(context, { documentCode, file }) {
    const formData = new FormData()
    formData.append('document_code', documentCode || '')
    formData.append('file', file)
    const response = await apiPostAuth(API_CLAIM.DOCUMENT_STRUCTURE_CHECK, formData)
    return response.data
  }
}

const getters = {
  get_claim_list: state => {
    return state.claim_list
  },
  get_claim_dashboard_list: state => {
    return state.claim_dashboard_list
  },
  get_detail_claim: state => {
    return state.detail_claim
  },
  get_claim_history: state => {
    return state.claim_history
  },
  get_employee_program_balance: state => {
    return state.employee_program_balance
  },
  get_employee_program_list: state => {
    return state.employee_program_list
  },
  get_participant_data: state => {
    return state.participant_data
  },
  get_modal_info: state => {
    return state.modal_info
  },
  get_document_support_claim: state => {
    return state.document_support_claim
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  get_detail_modal_preview: state => {
    return state.detail_modal_preview
  },
  get_claim_mapping: state => {
    return state.claim_mapping
  },
  get_optional_document_files: state => {
    return state.optional_document_files
  },
  get_document_files_by_type_id: state => {
    return state.document_files_by_type_id
  },
  meta_filter: state => {
    return state.meta_filter
  },
  meta_filter_2: state => {
    return state.meta_filter_2
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
